import Cookie from "js-cookie";
import CONSTANTS from "modules/utils/constants";
import RallySSO from "modules/utils/SSO/rallySSO";
import {createFanHubEvent, EventGUID} from 'modules/utils/analytics/analytics';

export const getMlbPlatform = () => Cookie.get("platform");

export const originGameURL = window.location.href;

const RELOADED_QS_KEY = "reloaded";

/**
 * Get a flag about reload attempt.
 * It means that after unauthorized error we have tried to reload the page at least one time
 */
export const isGameReloaded = () => {
	try {
		return Boolean(Cookie.get(RELOADED_QS_KEY));
	} catch (e) {
		console.info(e);
	}

	return false;
};
/**
 * Removes a flag about reload attempt.
 */
export const removeGameReloaded = () => {
	try {
		Cookie.remove(RELOADED_QS_KEY);
	} catch (e) {
		console.info(e);
	}
};
/**
 * Adds a flag about reload attempt.
 * It means that after unauthorized error we have tried to reload the page at least one time
 */
export const appendReloadMarker = () => {
	try {
		Cookie.set(RELOADED_QS_KEY, "true");
	} catch (e) {
		console.info(e);
	}
};

export const redirectToMlbIneligible = () => {
	deeplinkOrWebRedirect("https://www.mlb.com/apps/beat-the-streak/ineligible");
};

export const redirectToMlbLoginForm = () => {
	const url = `${CONSTANTS.BASE_DOMAIN}/play?redirectUrl=${CONSTANTS.BASE_DOMAIN}${CONSTANTS.BASE_URL}&gameId=${CONSTANTS.GAME_ID}`;
	deeplinkOrWebRedirect(url);
};

export const redirectToMlbLoginOnBoarding = () => {
	deeplinkOrWebRedirect(`${CONSTANTS.BASE_DOMAIN}/play/onboarding?step=updateAccount`);
};

export const deeplinkOrWebRedirect = (href: string, timeout = 1000) => {
	window.location.href = "mlbplay://com.mlbam.BTS/game?home=1";

	setTimeout(() => {
		window.location.href = href;
	}, timeout);
};

export const inviteToGroup = (leagueCode: string) => {
	if (RallySSO.IS_NATIVE) {
		RallySSO.nativeBridge?.inviteToGroup(CONSTANTS.GAME_ID, leagueCode);
		return;
	}
	window.open(
		`${CONSTANTS.BASE_DOMAIN}/play?gameId=${CONSTANTS.GAME_ID}&groupId=${leagueCode}`,
		"_blank"
	);
};

export function getSponsorLink(_countryCode: string | null) {
	return null;
}

export const redirectForSponsor = (countryCode: string | null) => {
	const sponsorUrl = getSponsorLink(countryCode);

	if (!sponsorUrl) {
		return;
	}
	createFanHubEvent(EventGUID.SPONSOR_CLICK);
	if (RallySSO.IS_NATIVE) {
		RallySSO.nativeBridge?.launchExternal(sponsorUrl);
		return;
	}

	window.open(sponsorUrl, "_blank");
};
